<template>
  <div
    :class="['book-landing landing-page', { 'mobile': $q.platform.is.mobile }]"
    :style="styles"
  >
    <div
      v-if="headerTrackingCode"
      v-html="headerTrackingCode"
    />
    <OfferComponent v-if="pageData.offerEnable" />
    <StickyOfferComponent v-if="pageData.offerEnable" />
    <HeaderComponent
      v-if="pageData.headerEnable"
      with-button
    />
    <PromoComponent v-if="pageData.promoEnable" />
    <OverviewComponent v-if="pageData.overviewEnable" />
    <FeaturesGridComponent v-if="pageData.featuresGridEnable" />
    <FeaturesListComponent v-if="pageData.featuresListEnable" />
    <RatingComponent v-if="pageData.ratingEnable" />
    <CarouselComponent v-if="pageData.carouselEnable" />
    <CallToActionComponent v-if="pageData.callToActionEnable" />
    <PriceComponent v-if="pageData.priceEnable" />
    <FooterComponent v-if="pageData.footerEnable" />
    <div
      v-if="footerTrackingCode"
      v-html="footerTrackingCode"
    />

    <EmailFormDialog
      v-if="showEmailFormDialog"
      :style="styles"
      @hide="showEmailFormDialog = false"
    />
  </div>
</template>

<script setup>
import OfferComponent from 'components/book-landing/render/OfferComponent.vue';
import StickyOfferComponent from 'components/book-landing/render/StickyOfferComponent.vue';
import HeaderComponent from 'components/book-landing/render/HeaderComponent.vue';
import PromoComponent from 'components/book-landing/render/PromoComponent.vue';
import OverviewComponent from 'components/book-landing/render/OverviewComponent.vue';
import FeaturesGridComponent from 'components/book-landing/render/FeaturesGridComponent.vue';
import FeaturesListComponent from 'components/book-landing/render/FeaturesListComponent.vue';
import CarouselComponent from 'components/book-landing/render/CarouselComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import CallToActionComponent from 'components/book-landing/render/CallToActionComponent.vue';
import RatingComponent from 'components/book-landing/render/RatingComponent.vue';
import FooterComponent from 'components/book-landing/render/FooterComponent.vue';
import PriceComponent from 'components/book-landing/render/PriceComponent.vue';
import EmailFormDialog from 'components/book-landing/dialog/EmailFormDialog.vue';
import { ref, inject, onUnmounted } from 'vue';
import useBookPageEdit from 'src/composables/useBookPageEdit';
import { useQuasar } from 'quasar';

const $q = useQuasar();
const bus = inject('bus');
const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);

const { styles, headerTrackingCode, footerTrackingCode } = useBookPageEdit();

const showEmailFormDialog = ref(false);

bus.on('open-email-form', () => {
  showEmailFormDialog.value = true;
});

onUnmounted(() => {
  bus.off('open-email-form');
});
</script>
